import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Input, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoginContext } from "../../../contexts/loginContext";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";



const SectorManagement = () => {
  // const { isLoggedIn, adminId: admin_id } = useContext(LoginContext);
  const [sectorName, setSectorName] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [sectorData, setSectorData] = useState([]);
  const [sectorId, setSectorId] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [deactivateId, setDeactiveId] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const admin_id = user?.user_id;
  const { COLORS } = useThemeMode();
  

  const aiDishaApi = createInstance("DISHA");

  useEffect(() => {
    fetchData();
    console.log("usercheck",admin_id)
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/all-sector`);
      console.log("Fetched data from API:", response.data);
  
      if (response.data?.sectors) {
        setSectorData(response.data.sectors);
      } else {
        console.error("Unexpected response structure:", response.data);
      }
    } catch (error) {
      console.error(
        "Error fetching sector data:",
        error.response?.data?.message || error.message
      );
    }
  };
  

  useEffect(() => {
    if (sectorName === "") {
      setPage(0); // Reset pagination to the first page
      setIsEdit(false); // Exit edit mode
    }
  }, [sectorName]);

  const handleSort = (field) => {
    const sortedData = [...sectorData].sort((a, b) => {
      if (sortingOrder === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });
    setSectorData(sortedData);
    setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };
  // Filter sector data based on search term
  const filteredSectorData = sectorData.filter((sector) =>
    sector.sector_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // const handleSectorSubmit = async () => {
  //   if (isSubmitting) return;

  //   try {
  //     setIsSubmitting(true);

  //     if (!sectorName.trim()) {
  //       Toast.error("Sector name cannot be empty");
  //       return;
  //     }

  //     const existingSector = sectorData.find(
  //       sector => sector.sector_name.toLowerCase() === sectorName.toLowerCase()
  //     );
      
  //     if (existingSector) {
  //       Toast.error("Sector name already exists");
  //       return;
  //     }

  //     const response = await aiDishaApi.post("/admin-sectors/", {
  //       admin_id,
  //       sector_name: sectorName.trim(),
  //       creation_date: new Date().toISOString(),
  //       status: "Active"
  //     });

  //     if (response.status === 200) {
  //       Toast.success("Sector added successfully");
  //       setSectorName("");
  //       await fetchData();
  //     }
  //   } catch (error) {
  //     Toast.error(error.response?.data?.message || "Failed to add sector");
  //     console.error("Error adding sector:", error);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSectorSubmit = async () => {
    try {
      if (!sectorName.trim()) {
        console.error("Sector name cannot be empty");
        Toast.error("Sector name cannot be empty");
        return;
      }
      const existingSector = sectorData.find((sector) => sector.sector_name === sectorName);
      if (existingSector) {
        console.error("Sector name already exists");
        Toast.error("Sector name already exists");
        return;
      }
      console.log(admin_id + sectorName)
      const response = await aiDishaApi.post("/admin-sectors/", {
        admin_id: admin_id,
        sector_name: sectorName,
        creation_date: creationDate,
        status: "Active",
      });

      if (response.status === 200) {
        Toast.success("Sector added successfully");
        setSectorName("");
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEdit = (id, name) => {
    setSectorId(id);
    setEditedName(name);
    setSectorName(name);
    setIsEdit(true);
  }

  const handleSectorEdit = async (sector_id) => {
    try {
      const existingSector = sectorData.find(
        sector => sector.sector_name.toLowerCase() === sectorName.toLowerCase() 
        && sector.sector_id !== sector_id
      );
      
      if (existingSector) {
        Toast.error("Sector name already exists");
        return;
      }
  
      // Modify the endpoint URL to match your backend API structure
      const updateResponse = await aiDishaApi.put(
        `/admin-sectors-update/${admin_id}/${sector_id}`, // Remove admin_id from URL if not needed
        {
          sector_name: sectorName,
          admin_id: admin_id,
          updated_date: new Date().toISOString(),
          status: "Active"
        }
      );
  
      if (updateResponse.status === 200) {
        Toast.success("Sector updated successfully");
        setSectorName("");
        fetchData();
        setIsEdit(false);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        Toast.error("Unable to update sector. Endpoint not found.");
      } else {
        Toast.error("Failed to update sector. Please try again.");
      }
      console.error("Error:", error);
    } finally {
      setEditingRowId(null);
    }
  };

  const handleClear = () => {
    setSectorName("");
    setSectorId(null);
    setSearchTerm("");

  };

  const handleModalOpen = (sector_id,status) => {
    setDeactiveId(sector_id);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDeactivateSector = async (deactivateId,currentStatus) => {
    try {
      const newStatus = currentStatus  === "Active" ? "Inactive" : "Active";

      const response = await aiDishaApi.patch(`/admin-sectors-status/?admin_id=${admin_id}&sector_id=${deactivateId}&status_update=${newStatus}`
    );
      if (response.status === 200) {
        Toast.success("Sector deactivated successfully");
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const sectorHeader = [
    {
      id: "Sector ID",
      name: "Sector Name",
      creationDate: "Creation Date",
      action: "Action",
    },
  ];

  const CssTextField = styled(TextField)({
    "& label": {
      color: "#FEFEFE",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#B9B9B9",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "#B9B9B9",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B9B9B9",
      },
      "& .MuiInputBase-input": {
        color: "#FEFEFE",
      },
    },
  });

  return (
    <div>
      {isEdit ? (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            // background: alpha("#B9B9B9", 0.2),
            background: COLORS.primary,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}>
              Edit Sector
            </Typography>
            <Typography sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}>
              Edit the name of the Sector
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                background: COLORS.background, // Set background color to black
              }}
            >
              <IconButton type="button" sx={{ p: "8px", color: COLORS.text }} aria-label="search">
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, 
                  fontFamily: "Poppins", 
                  color: COLORS.text,
                "& input::placeholder": {
                                             color: `${COLORS.text} !important`, // 👈 placeholder color
                                             opacity: 10, // important (MUI reduces opacity by default)
                                           },}} // Set text color to white
                placeholder="Search by Sector Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>
          <Box gridColumn="span 5" sx={{ marginTop: "auto", textAlign: "left" }}>
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              Sector Name
            </Typography>
            <TextField
              size="small"
              id="custom-css-outlined-input"
              label="Sector Name"
              variant="outlined"
              value={sectorName}
              onChange={(e) => setSectorName(e.target.value)}
              sx={{
                borderRadius :2,
                background:COLORS.background,
                width: "95%", "& .MuiOutlinedInput-root": {
                   "& input": {
                   color: COLORS.text, // 👈 input text color
                 },
               },
              
               /* ✅ Label color (default) */
    "& .MuiInputLabel-root": {
      color: COLORS.text,
    },
                /* ✅ Label color when focused */
    "& .MuiInputLabel-root.Mui-focused": {
      color: COLORS.text,
    },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: COLORS.border, borderRadius: "10px" , color:COLORS.text },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline": {
                  borderColor: COLORS.borer
                }
              }}
              required />

          </Box>

          <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}>
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}>
            <Button
              sx={{
                background: COLORS.button,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                color: COLORS.background,
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => handleSectorEdit(sectorId)}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.background }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            // background: alpha("#B9B9B9", 0.2),
            background: COLORS.primary,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}>
              Add Sector
            </Typography>
            <Typography sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}>
              Add the name of the Sector
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                backgroundColor: COLORS.background, // Set background color to black
              }}
            >
              <IconButton type="button" sx={{ p: "8px", color: COLORS.text }} aria-label="search">
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, 
                  fontFamily: "Poppins", 
                  color: COLORS.text,
                "& input::placeholder": {
                                             color: `${COLORS.text} !important`, // 👈 placeholder color
                                             opacity: 10, // important (MUI reduces opacity by default)
                                           }, }} // Set text color to white
                placeholder="Search by Sector Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>


          <Box gridColumn="span 5" sx={{ marginTop: "auto", textAlign: "left" }}>
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              Sector Name
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Sector Name"
              variant="outlined"
              value={sectorName}
              onChange={(e) => setSectorName(e.target.value)}
              sx={{
                background:COLORS.background,
                borderRadius :2,
                width: "95%",
                 "& .MuiOutlinedInput-root": {
                   "& input": {
                   color: COLORS.text, // 👈 input text color
                 },
               },
               /* ✅ Label color (default) */
    "& .MuiInputLabel-root": {
      color: COLORS.text,
    },

    /* ✅ Label color when focused */
    "& .MuiInputLabel-root.Mui-focused": {
      color: COLORS.text,
    },
    /* ✅ Border color */
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.secondary,
    },

    /* ✅ Border color on hover */
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.secondary,
    },

    /* ✅ Border color when focused */
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: COLORS.secondary,
    },
                // "& .MuiOutlinedInput-notchedOutline": { borderColor: "white", borderRadius: "10px" },
                // "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline": {
                //   borderColor: "grey"
                // }
              }}
              required
            />
          </Box>

          <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}>
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}>
            <Button
              sx={{
                background: COLORS.button,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                color: COLORS.background,
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={handleSectorSubmit}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.background }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      )}

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {sectorHeader.map(({ id, name, creationDate, action }) => (
                    <React.Fragment key={id}>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {id}
                      </TableCell>
                      <TableCell
                        sx={{ color: COLORS.text, borderBottom: 0, cursor: "pointer" }}
                        onClick={() => handleSort("sector_name")}
                      >
                        {name} {sortingOrder === "asc" ? "↑" : "↓"}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {creationDate}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {action}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredSectorData && filteredSectorData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n, index) => (
                      <TableRow
                        key={n.sector_id}
                        sx={{ background: COLORS.background, marginRight: "30px" }}
                      >
                        <TableCell sx={{ color: COLORS.text, borderBottom: COLORS.secondary }}>
                          {n.sector_id}
                        </TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: COLORS.secondary }}>
                          {editingRowId === n.sector_id ? (
                            <Input
                              value={editedName}
                              onChange={(e) => setEditedName(e.target.value)}
                            />
                          ) : (
                            n.sector_name
                          )}
                        </TableCell>
                        <TableCell sx={{ color: COLORS.text, borderBottom: COLORS.secondary }}>
                          {new Date(n.creation_date).toLocaleDateString('en-GB')}
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: COLORS.secondary,
                            borderRight: COLORS.border,
                            display: "flex",
                            alignItems: "center",
                            fontFamily: "poppins",
                          }}
                        >
                          {editingRowId === n.sector_id ? (
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "black",
                                color: "white",
                                marginRight: "10px",
                                fontFamily: "poppins",
                                height: "20px",
                                width: "30px",
                              }}
                            >
                              Save
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              onClick={() => handleEdit(n.sector_id, n.sector_name)}
                              sx={{
                                background: COLORS.button_edit_bg,
                                "&hover":{
                                  background: COLORS.hover_edit_btn,
                                  },
                                color: COLORS.text,
                                marginRight: "10px",
                                fontFamily: "poppins",
                                height: "20px",
                                width: "30px",
                              }}
                            >
                              Edit
                            </Button>
                          )}
                          <Button
                            variant="contained"
                            sx={{
                                backgroundColor:
                                  n.status === "Active"
                                    ? COLORS.button_red_bg
                                    : COLORS.button_green_bg,
                                color: COLORS.text,
                                "&:hover": {
                                   background:
                                     n.status === "Active"
                                       ? COLORS.hover_red_btn      // hover when Active (Deactivate button)
                                       : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
                                 },
                                color: COLORS.text,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => {
                                console.log(
                                  "Deactivate button clicked for:",
                                  n.sector_id , n.status
                                );
                                handleModalOpen(n.sector_id, n.status);
                              }}
                            // sx={{
                            //   color: "white",
                            //   marginLeft: "20px",
                            //   fontFamily: "poppins",
                            //   height: "20px",
                            //   width: "100px",
                            // }}
                            // onClick={() => handleModalOpen(n.sector_id)}
                            // color="error"
                          >
                            {/* DeActivate */}
                            {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={filteredSectorData ? filteredSectorData.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  background: COLORS.primary,
                  color: COLORS.text,
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal 
      isOpen={isModalOpen} 
      onClose={handleModalClose} 
      title="Sector"
      action={() => handleDeactivateSector(deactivateId,selectedStatus)}
      actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}


      //  action={handleDeactivateSector} 
      />
    </div>
  );
};

export default SectorManagement;